// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assests/images/wallpaper.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .table-header th {
    background-color: skyblue;
   
  } */
.qr-code-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  font-size: 10px;
}

.qr-con {
  border: 20px solid #96dc00;
  border-radius: 10px;
  margin-top: 5px;
  margin: 5px;
  width: calc(40% - 20px);

  box-sizing: border-box;
}

.qr-con .row {
  display: flex;
  flex-direction: row;
}

.qr-view-container {
  display: block;
  justify-content: center;
  align-items: center;
  height: 100vh;
}


.qr-box {
  border: 1px solid #000;
  padding: 20px;
  margin: 40px 40%;
  border-radius: 10px 20px 10px 30px;
}

.toastBody {
  font-size: 1rem;
}

.login-wall {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-size: cover;
  background-position: center;

  width: 100%;
}

.progress-bar-fill {
  height: 20px;
  /* Adjust height as needed */
  display: flex;
  /* Arrange segments side-by-side */
  position: relative;
  /* Enable positioning for the animation */
}

.progress-bar-fill span {
  /* Adjust individual segment styling */
  transition: width 0.5s ease-in-out;
  /* Add smooth transition */
}



.progress-bar-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: #fff;
  transition: width 0.5s ease-in-out;
}

.tooltip {

  position: absolute;
  top: -30px;
}

@media print {
  .header {
    display: none !important;
  }

  .no-print {
    display: none !important;
  }

  body {
    margin: 20px;
    overflow: visible !important;

  }

  .pdf-container .table thead {
    background: #F0E9EA;
  }


}

.content-wrapper {
  margin-left: 10px !important;
  margin-right: 10px !important;

}

/* App.css */
/* .app-container {
  display: flex;
  flex-wrap: wrap;
}

.sidebar-container {
  width: 20%;
  min-width: 200px;
}

.content-container {
  width: 80%;
  flex-grow: 1;
} */

/* App.css */

.app-container {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}

.sidebar-container {
  width: 250px;
  flex-shrink: 0;
  background-color: #f8f9fa;
  transition: width 0.3s ease;
}

.content-container {

  /* flex-grow: 1;
  background-color: #ffffff;
  transition: margin-left 0.3s ease; */

  width: 80%;
  flex-grow: 1;
}

@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
  }

  .sidebar-container {
    width: 100%;
    height: auto;
  }

  .content-container {
    margin-left: 0;
    padding: 10px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar-container {
    width: 100px;
  }

  .content-container {
    margin-left: 130px;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 5px;
  }
}

/* Container for profile image upload */
.profile-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

/* Profile image wrapper */
.profile-image {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 20px;
}

.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Upload button styling */
.upload-btn {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 15px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
}

/* Input hidden */
.profile-upload-input {
  display: none;
}

/* Clear button styling */
.clear-btn {
  margin-top: 10px;
  background-color: red;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.clear-btn:hover {
  background-color: darkred;
}

/* Parent container to limit overflow during zoom */
.image-container {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: zoom-in;
}

/* Zoom effect on hover */
.zoomable-img {
  transition: transform 0.3s ease, cursor 0.3s ease;
}

/* Zoomed in effect */
.image-container:hover .zoomable-img {
  transform: scale(1.5);
  /* Adjust scale as per requirement */
  cursor: zoom-out;
}
.ant-select-selector {
  width: 100%;
  height: calc(2.25rem + 2px) !important;
  border: none;
}

.navbar {

  padding: 0.0rem 0.1rem !important;
}

.table-responsive {
  width: 100%;
}

.table-responsive > table {
  width: 100% !important;
  table-layout: fixed;
}
.amtqty-div .text-center{
  margin-top: 0rem !important;
  padding-bottom: 0rem !important;
  
}
.amtqty-div .card-body{
  padding: 0.5rem !important ;
}
.amtqty-div .card-body .col-3 p{
  margin-bottom: 0rem !important;

}
.p-bottom{
  margin-bottom: 0rem !important;

}
.left-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.agri-dash::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.5);
  /* Light scrollbar */
  border-radius: 4px;
}
 
.agri-dash::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  /* Transparent track */
}
 
.agri-dash::-webkit-scrollbar {
  width: 6px;
}

.tableheaderrowview th {
  background-color: #e8f0fe !important; /* Group Header like "Farmer Details" */
  color: #333;
  font-weight: bold;
  text-align: center;
}

.table-subheader th {
  background-color: #f5f5f5 !important; /* Column Labels */
  color: #000;
  font-weight: 500;
  text-align: center;
}

.table-row-even {
  background-color: #ffffff;
}

.table-row-odd {
  background-color: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;KAGK;AACL;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oEAAuE;EACvE,sBAAsB;EACtB,2BAA2B;;EAE3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;AAC5B;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,4BAA4B;;EAE9B;;EAEA;IACE,mBAAmB;EACrB;;;AAGF;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;;AAE/B;;AAEA,YAAY;AACZ;;;;;;;;;;;;;GAaG;;AAEH,YAAY;;AAEZ;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE;;sCAEoC;;EAEpC,UAAU;EACV,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,+BAA+B;;AAEjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;;AAEhC;AACA;EACE,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC,EAAE,uCAAuC;EAC7E,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC,EAAE,kBAAkB;EACxD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* .table-header th {\n    background-color: skyblue;\n   \n  } */\n.qr-code-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  font-size: 10px;\n}\n\n.qr-con {\n  border: 20px solid #96dc00;\n  border-radius: 10px;\n  margin-top: 5px;\n  margin: 5px;\n  width: calc(40% - 20px);\n\n  box-sizing: border-box;\n}\n\n.qr-con .row {\n  display: flex;\n  flex-direction: row;\n}\n\n.qr-view-container {\n  display: block;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n\n.qr-box {\n  border: 1px solid #000;\n  padding: 20px;\n  margin: 40px 40%;\n  border-radius: 10px 20px 10px 30px;\n}\n\n.toastBody {\n  font-size: 1rem;\n}\n\n.login-wall {\n  background-image: url(\"../src/assests/images/wallpaper.jpg\") !important;\n  background-size: cover;\n  background-position: center;\n\n  width: 100%;\n}\n\n.progress-bar-fill {\n  height: 20px;\n  /* Adjust height as needed */\n  display: flex;\n  /* Arrange segments side-by-side */\n  position: relative;\n  /* Enable positioning for the animation */\n}\n\n.progress-bar-fill span {\n  /* Adjust individual segment styling */\n  transition: width 0.5s ease-in-out;\n  /* Add smooth transition */\n}\n\n\n\n.progress-bar-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #fff;\n  transition: width 0.5s ease-in-out;\n}\n\n.tooltip {\n\n  position: absolute;\n  top: -30px;\n}\n\n@media print {\n  .header {\n    display: none !important;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n\n  body {\n    margin: 20px;\n    overflow: visible !important;\n\n  }\n\n  .pdf-container .table thead {\n    background: #F0E9EA;\n  }\n\n\n}\n\n.content-wrapper {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n\n}\n\n/* App.css */\n/* .app-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.sidebar-container {\n  width: 20%;\n  min-width: 200px;\n}\n\n.content-container {\n  width: 80%;\n  flex-grow: 1;\n} */\n\n/* App.css */\n\n.app-container {\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n\n.sidebar-container {\n  width: 250px;\n  flex-shrink: 0;\n  background-color: #f8f9fa;\n  transition: width 0.3s ease;\n}\n\n.content-container {\n\n  /* flex-grow: 1;\n  background-color: #ffffff;\n  transition: margin-left 0.3s ease; */\n\n  width: 80%;\n  flex-grow: 1;\n}\n\n@media (max-width: 768px) {\n  .app-container {\n    flex-direction: column;\n  }\n\n  .sidebar-container {\n    width: 100%;\n    height: auto;\n  }\n\n  .content-container {\n    margin-left: 0;\n    padding: 10px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .sidebar-container {\n    width: 100px;\n  }\n\n  .content-container {\n    margin-left: 130px;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .content-container {\n    padding: 5px;\n  }\n}\n\n/* Container for profile image upload */\n.profile-upload-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n/* Profile image wrapper */\n.profile-image {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.profile-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Upload button styling */\n.upload-btn {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  padding: 5px 15px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n/* Input hidden */\n.profile-upload-input {\n  display: none;\n}\n\n/* Clear button styling */\n.clear-btn {\n  margin-top: 10px;\n  background-color: red;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.clear-btn:hover {\n  background-color: darkred;\n}\n\n/* Parent container to limit overflow during zoom */\n.image-container {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  cursor: zoom-in;\n}\n\n/* Zoom effect on hover */\n.zoomable-img {\n  transition: transform 0.3s ease, cursor 0.3s ease;\n}\n\n/* Zoomed in effect */\n.image-container:hover .zoomable-img {\n  transform: scale(1.5);\n  /* Adjust scale as per requirement */\n  cursor: zoom-out;\n}\n.ant-select-selector {\n  width: 100%;\n  height: calc(2.25rem + 2px) !important;\n  border: none;\n}\n\n.navbar {\n\n  padding: 0.0rem 0.1rem !important;\n}\n\n.table-responsive {\n  width: 100%;\n}\n\n.table-responsive > table {\n  width: 100% !important;\n  table-layout: fixed;\n}\n.amtqty-div .text-center{\n  margin-top: 0rem !important;\n  padding-bottom: 0rem !important;\n  \n}\n.amtqty-div .card-body{\n  padding: 0.5rem !important ;\n}\n.amtqty-div .card-body .col-3 p{\n  margin-bottom: 0rem !important;\n\n}\n.p-bottom{\n  margin-bottom: 0rem !important;\n\n}\n.left-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.agri-dash::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.5);\n  /* Light scrollbar */\n  border-radius: 4px;\n}\n \n.agri-dash::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  /* Transparent track */\n}\n \n.agri-dash::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tableheaderrowview th {\n  background-color: #e8f0fe !important; /* Group Header like \"Farmer Details\" */\n  color: #333;\n  font-weight: bold;\n  text-align: center;\n}\n\n.table-subheader th {\n  background-color: #f5f5f5 !important; /* Column Labels */\n  color: #000;\n  font-weight: 500;\n  text-align: center;\n}\n\n.table-row-even {\n  background-color: #ffffff;\n}\n\n.table-row-odd {\n  background-color: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
